/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

import styled from "styled-components";

export function MenuBreak({ condition = true }: { condition?: boolean }) {
  return condition ? <StyledBreak /> : <></>;
}

const StyledBreak = styled.div`
  height: 1px;
  width: 100%;
  background-color: ${({ theme }) => theme.subtleContrast};
`;
